exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clearb{clear-after:both}.ccard{margin-top:10px;margin-bottom:10px;width:100%;padding-left:8px;padding-right:8px}.ccard .ccard-header{border-bottom:1px solid #a39577;margin-bottom:8px;cursor:pointer;color:#7a797b;font-weight:600;font-size:14px;font-style:italic;text-transform:none;font-smooth:always;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.ccard .ccard-header .icon{transform:rotate(180deg);transition:transform .15s ease-out;float:right!important;color:#7a797b}.ccard.not-expanded .ccard-header .icon{transform:rotate(0deg)}", ""]);

// exports
